import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getprivacypolicy,
  updateprivacypolicy,
} from "../../../services/privacypolicy";

/**
 * Lets an admin maintain the privacy policy text shown to everyone on the
 * login page (see the "Privacy Policy" link there). One record per
 * deployment/client, same single-record pattern as the restrictions settings.
 */
const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadPolicy();
  }, []);

  function loadPolicy() {
    setLoading(true);
    getprivacypolicy()
      .then((res) => {
        if (res?.status === true && res.data) {
          setContent(res.data.content ?? "");
          setLastUpdated(res.data.updated_at ?? "");
        }
      })
      .finally(() => setLoading(false));
  }

  function submitPolicy(e) {
    e.preventDefault();

    // if (!content.trim()) {
    //   toast.error("Privacy policy content cannot be empty.");
    //   return;
    // }

    const temp = new FormData();
    temp.append("content", content);

    setSaving(true);
    updateprivacypolicy(temp)
      .then((res) => {
        if (res?.status === true) {
          if (res.data?.updated_at) {
            setLastUpdated(res.data.updated_at);
          }
        } else if (res?.message) {
          toast.error(res.message);
        }
      })
      .finally(() => setSaving(false));
  }

  return (
    <div>
      <div className="container-fluid">
        <div className="page-header">
          <h2 className="main-content-title tx-24 mg-b-5">Privacy Policy
          </h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Settings</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Privacy Policy
            </li>
          </ol>
        </div>
        <div className="content-body">
          <div className="card custom-card">
            <div className="card-body">
              <p className="tx-12 text-muted mb-3">
                This is shown to everyone via the "Privacy Policy" link on the
                login page, including people who haven't signed in yet. Plain
                text or simple HTML is fine.
              </p>

              {loading ? (
                <p className="text-muted">Loading...</p>
              ) : (
                <form onSubmit={submitPolicy}>
                  <div className="form-group mb-3">
                    <label className="form-label fw-semibold" htmlFor="privacy-policy-content">
                      Policy Content
                    </label>
                    <textarea
                      id="privacy-policy-content"
                      className="form-control"
                      rows="18"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                      placeholder="Enter the privacy policy text shown to users..."
                    />
                  </div>

                  <div className="row border-top pt-3">
                    <div className="col-md-12 text-end">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={saving}
                      >
                        {saving ? "Saving..." : "Save Privacy Policy"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>

      </div>

    </div>


  );
};

export default PrivacyPolicy;
